import { specialFont } from "../../Infrastructure/Theme/fontFamily";

export const styles = {
  root: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100vh",
    bgcolor: "#f5f5f5",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    textAlign: "center",
    px: 3,
  },
  logo: {
    width: 150,
    mb: 3,
  },
  heading: {
    mb: 1,
    fontFamily: specialFont,
  },
};
